<template>
	<div>
		<img src="../assets/banner.jpg" alt="" style="width: 100%;">
		<div style="background: #F5F5F5;">
			<div class="mian">
				<div class="head fcs">
					<div class="title fcc">注册</div>
					<div class="fanhui fcc" @click="fanhui">返回</div>
				</div>
				<div class="content">
					<div class="title fcc">基本信息</div>
					<div class="fc">
						<div class="inputbox fc">
							<div style="width: 80px;">公司名称</div>
							<el-input v-model="registerform.corporate_name" placeholder="请输入公司名称"
								style="width: 250px;"></el-input>
						</div>
						<div class="inputbox fc">
							<div style="width: 80px;">注册分类</div>
							<el-select v-model="registerform.category_id" style="width: 250px;" placeholder="请选择注册分类"
								@change="selectchange">
								<el-option label="专项工程分包供应商" value="1"></el-option>
								<el-option label="材料供应商" value="2"></el-option>
								<el-option label="劳务供应商" value="3"></el-option>
								<el-option label="设备供应商" value="4"></el-option>
								<el-option label="其他物资供应商" value="5"></el-option>
							</el-select>
						</div>
					</div>
					<div class="fc">
						<div class="inputbox fc">
							<div style="width: 80px;">联系人</div>
							<el-input v-model="registerform.name" placeholder="请输入联系人名称"
								style="width: 250px;"></el-input>
						</div>
						<div class="inputbox fc">
							<div style="width: 80px;">登录密码</div>
							<el-input v-model="registerform.password" placeholder="请输入登录密码" show-password
								style="width: 250px;"></el-input>
						</div>
					</div>
					<div class="fc">
						<div class="inputbox fc">
							<div style="width: 80px;">手机号</div>
							<el-input v-model="registerform.mobile" placeholder="请输入联系人手机号"
								style="width: 250px;"></el-input>
						</div>
						<div class="inputbox fc">
							<div style="width: 80px;">验证码</div>
							<el-input v-model="registerform.code" placeholder="请输入验证码" style="width: 140px;"></el-input>
							<div class="btns" v-if="!disabledCode" @click="obtain">{{codeText}}</div>
							<div class="btns" v-else style="color: #CCC8C8;">{{codeText}}</div>
						</div>
					</div>
					<div style="height: 50px;"></div>
					<div class="title fcc">营业执照(图片)</div>
					<el-upload class="avatar-uploader" action="http://zbpt.zjjljs.cn/api/common/upload"
						:show-file-list="false" :on-success="handleAvatarSuccess1">
						<img v-if="registerform.business_license" :src="registerform.business_license" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<div style="margin-top: 50px;"
						v-if="registerform.category_id == '1' || registerform.category_id == '3'">
						<div class="title fcc">资质证书</div>
						<el-upload class="avatar-uploader" action="http://zbpt.zjjljs.cn/api/common/upload"
							:show-file-list="false" :on-success="handleAvatarSuccess2">
							<img v-if="registerform.zzzs" :src="registerform.zzzs" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</div>
					<div style="margin-top: 50px;" v-if="registerform.category_id == '4'">
						<div class="title fcc">其他证明资料</div>
						<el-upload class="avatar-uploader" action="http://zbpt.zjjljs.cn/api/common/upload"
							:show-file-list="false" :on-success="handleAvatarSuccess3">
							<img v-if="registerform.sbzmcl" :src="registerform.sbzmcl" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</div>
					<div class="fcc" style="margin-top: 30px;">
						<el-button type="primary" style="width: 140px;" @click="registerbtn">注册</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				registerform: {
					name: '', //姓名
					mobile: '', //手机号
					code: '', //验证码
					password: '', //密码
					corporate_name: '', //公司名称
					business_license: '', //营业执照
					category_id: '', //注册分类
					zzzs: '', //资质证书
					sbzmcl: '' //其他证明资料
				},
				disabledCode: false,
				codeText: '获取验证码',
			}
		},
		created() {

		},
		methods: {
			//注册
			registerbtn() {
				if (this.registerform.category_id == '1' || this.registerform.category_id == '3') {
					if (this.registerform.zzzs == '') {
						alert('请先上传资质证书')
						return;
					}
				}
				if (this.registerform.category_id == '4') {
					if (this.registerform.sbzmcl == '') {
						alert('请先上传其他证明资料')
						return;
					}
				}
				this.$api.home.register(this.registerform).then(res => {
					if (res.code == 1) {
						this.$alert('注册成功，等待后台审核', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								setTimeout(() => {
									location.reload();
								}, 1500)
							}
						});
					}
				})
			},
			//上传营业执照
			handleAvatarSuccess1(e) {
				this.registerform.business_license = e.data.fullurl;
			},
			//上传资质证书
			handleAvatarSuccess2(e) {
				this.registerform.zzzs = e.data.fullurl;
			},
			//上传其他证明资料
			handleAvatarSuccess3(e) {
				this.registerform.sbzmcl = e.data.fullurl;
			},
			selectchange(e) {
				this.registerform.zzzs = '';
				this.registerform.sbzmcl = '';
			},
			fanhui() {
				this.$router.go(-1);
			},
			//获取验证码
			obtain() {
				let that = this;
				if (that.registerform.mobile == '') {
					alert('请先输入手机号')
					return;
				}
				let data = {
					mobile: that.registerform.mobile,
					event: 'register'
				}
				this.$api.home.send(data).then(res => {
					if (res.code == 1) {
						that.disabledCode = true;
						this.$message({
							message: '发送成功',
							type: 'success'
						});
						var time = 60;
						var timer = setInterval(fun, 1000);

						function fun() {
							time--;
							if (time >= 0) {
								that.codeText = time + "秒重新发送";
							} else if (time < 0) {
								that.codeText = "获取验证码";
								that.disabledCode = false;
								clearInterval(timer);
								time = 60;
							}
						}
					}
				})
			}
		}
	}
</script>

<style scoped>
	.mian {
		width: 1200px;
		margin: 0 auto;
		position: relative;
	}

	.mian .head {
		height: 70px;
		background: #ffffff;
		margin-top: -30px;
		z-index: 9999;
		box-sizing: border-box;
		padding-right: 30px;
	}

	.mian .head .title {
		height: 40px;
		padding-left: 14px;
		font-size: 22px;
		border-left: #2A69C8 solid 4px;
	}

	.mian .head .fanhui {
		width: 100px;
		height: 36px;
		background: #2A69C8;
		color: #ffffff;
		border-radius: 24px;
		cursor: pointer;
	}

	.mian .content {
		background: #ffffff;
		box-sizing: border-box;
		margin: 20px auto;
		padding: 30px 0;
	}

	.mian .content .title {
		display: block;
		height: 40px;
		padding-left: 14px;
		font-size: 22px;
		border-left: #2A69C8 solid 4px;
	}

	.mian .content .inputbox {
		width: 340px;
		margin: 0 auto;
		margin-top: 20px;
	}

	.avatar-uploader {
		margin: 30px 0 0 130px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		border: #8c939d solid 1px;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.btns {
		margin-left: 10px;
		font-size: 14px;
		color: #409EFF;
		cursor: pointer;
	}
</style>